import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/state/store';
import { setRouteListCardVisible } from '.';
import { getRouteImportInfo } from './getRouteImportInfo';
import { getRoutes } from './getRoutes';
import { getThirdPartyOrders } from './getThirdPartyOrders';
import { DeliveryState } from './state';

export const setNightEnd = createAsyncThunk(
  'delivery/setNightEnd',
  async (nightEnd: string, thunkAPI): Promise<string> => {
    const rootState: RootState = thunkAPI.getState() as RootState;
    const warehouseId = rootState.delivery.selectedWarehouseId;
    if (warehouseId) {
      thunkAPI.dispatch(
        getRoutes({ warehouseId, nightEnd, contextChange: true }),
      );
      thunkAPI.dispatch(getRouteImportInfo({ viewingNightEnd: nightEnd }));
      thunkAPI.dispatch(getThirdPartyOrders({ warehouseId, nightEnd }));
    }
    thunkAPI.dispatch(setRouteListCardVisible());
    return nightEnd;
  },
);

export const setNightEndFulfilled = (
  state: DeliveryState,
  action: PayloadAction<string>,
): void => {
  state.nightEnd.viewing = action.payload;
  // Clear route data so that stale responses from the previous nightEnd's
  // in-flight requests cannot persist in state. By the time this handler
  // runs, getRoutes.pending and getThirdPartyOrders.pending have already
  // fired (routesLoading / thirdPartyOrdersLoading = true), so the
  // MapContainer loading guards will prevent duplicate dispatches.
  state.routes = undefined;
  state.thirdPartyOrders = undefined;
  state.routeImport.scenarios = undefined;
  state.routeImport.actualRoutesSummary = undefined;
  state.routeImport.scenariosLoading = false;
  state.routeImport.scenariosError = false;
  state.deliveryStatuses = {
    routeStatuses: [],
    stopStatuses: [],
    redeliveryStopStatuses: [],
    loading: false,
  };
  state.deliveryPrimaryStatuses = {
    routeStatuses: [],
    stopStatuses: [],
    redeliveryStopStatuses: [],
    loading: false,
  };
};
